import { Box, Tab, Tabs } from '@mui/material';
import { FC, ReactElement, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { DefaultRootStateProps } from 'types';
import MainCard from '../cards/MainCard';
import Elements from './Elements';
import Steps from './Steps';

interface TabPanelProps {
  children: ReactElement;
  value: number;
  index: number;
}

const TabPanel: FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
    {value === index && <Box sx={{ p: 0, minHeight: '81vh' }}>{children}</Box>}
  </div>
);

const ElementsAndStepsTabs = ({ handleDragStart, currentStep, handleAdd, setStep, items, setItems, isEditing }: any) => {
  const form = useSelector((state: DefaultRootStateProps) => state.formBuilder);
  const intl = useIntl();
  const [value, setValue] = useState(0);
  const handleTabChange = (_: any, newTabValue: number) => setValue(newTabValue);
  return (
    <MainCard>
      <Tabs value={value} indicatorColor="primary" onChange={handleTabChange} aria-label="simple tabs example" variant="fullWidth">
        <Tab label={intl.formatMessage({ defaultMessage: 'Elements' })} />
        <Tab label={intl.formatMessage({ defaultMessage: 'Steps' })} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Elements
          isEditing={isEditing}
          handleDragStart={handleDragStart}
          handleAdd={handleAdd}
          isFromStepper={true}
          disabled={form?.steps?.some((step) => step?.items?.length <= 0) || false}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Steps
          isEditing={isEditing}
          currentStep={currentStep}
          handleAdd={handleAdd}
          disabled={form?.steps?.some((step) => step?.items?.length <= 0) || false}
        />
      </TabPanel>
    </MainCard>
  );
};

export default ElementsAndStepsTabs;
